import { render, staticRenderFns } from "./QueryFormSettings.vue?vue&type=template&id=06e84037&"
import script from "./QueryFormSettings.vue?vue&type=script&lang=ts&"
export * from "./QueryFormSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e84037')) {
      api.createRecord('06e84037', component.options)
    } else {
      api.reload('06e84037', component.options)
    }
    module.hot.accept("./QueryFormSettings.vue?vue&type=template&id=06e84037&", function () {
      api.rerender('06e84037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/form/QueryFormSettings.vue"
export default component.exports